(function($, Drupal) {

  Drupal.behaviors.contactForm = {
    attach: function(context) {

      var modalId = 'modal-note-return';

      $(once('write-us', '.webform-submission-schreiben-sie-uns-form', context)).each( function() {

        $(this).find('#edit-betreff').change(function () {

          if ($(this).val() === 'Produktqualität') {

            if (!$('#' + modalId).length) {
              $('body').append(`
<div class="modal modal--green fade" id="${modalId}" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-primary text-center">
      <div class="modal-header">
        <h5 class="h3 modal-title">Reklamation</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schlißen"></button>
      </div>
      <div class="modal-body">
        <p>Ihre Reklamation und Anmerkungen können Sie ganz einfach und unkompliziert über das Reklamationsformular abschicken.</p>
        <a href="/reklamation" class="btn btn-primary">Zur Reklamation</a>
      </div>
    </div>
  </div>
</div>
              `);
            }

            const myModal = new bootstrap.Modal(document.getElementById(modalId), {backdrop: 'static'})
            myModal.show();

          }
        })

      });

    }
  };

})(jQuery, Drupal);
